function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.34375 3.65625V6.34375H10V7.65625H7.34375V10.3438H6V7.65625H3.34375V6.34375H6V3.65625H7.34375ZM1.9375 2.3125C3.25 1 4.82292 0.34375 6.65625 0.34375C8.48958 0.34375 10.0625 1 11.375 2.3125C12.6875 3.60417 13.3438 5.16667 13.3438 7C13.3438 8.83333 12.6875 10.4062 11.375 11.7188C10.0625 13.0104 8.48958 13.6562 6.65625 13.6562C4.82292 13.6562 3.25 13.0104 1.9375 11.7188C0.645833 10.4062 0 8.83333 0 7C0 5.16667 0.645833 3.60417 1.9375 2.3125ZM2.90625 10.7812C3.94792 11.8229 5.19792 12.3438 6.65625 12.3438C8.13542 12.3438 9.39583 11.8229 10.4375 10.7812C11.4792 9.73958 12 8.47917 12 7C12 5.52083 11.4792 4.26042 10.4375 3.21875C9.39583 2.17708 8.13542 1.65625 6.65625 1.65625C5.19792 1.65625 3.94792 2.17708 2.90625 3.21875C1.86458 4.26042 1.34375 5.52083 1.34375 7C1.34375 8.47917 1.86458 9.73958 2.90625 10.7812Z",
  fill: "#2A2C37"
});

function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.a5f2742e.svg";
export { ForwardRef as ReactComponent };